import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalLoading from "../components/ModalLoading";
import { HEADER, getDataAxios } from "../utils/Utils";
import ButtonRequire from "../components/Button/ButtonRequire";
import axios from "axios";
import QRScanner from "./QRScanner";
import ErrorSheet from "../components/Sheet/ErrorSheet";
import V2MigrationBanner from "../components/Banner/V2MigrationBanner";

export default function RedeemFragment() {
  const user = JSON.parse(localStorage.getItem("dompet_user"));
  const dataOutlet = JSON.parse(localStorage.getItem("dompet_detail_outlet"));
  const [qrResult, setQrResult] = useState("");
  const [showModalLoading, setShowModalLoading] = useState(false);
  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (dataOutlet.status === "demo") {
      localStorage.clear();
      navigate("/signin");
    }
    return () => {};
  }, []);

  async function getDetailVoucher() {
    setShowModalLoading(true);
    try {
      var detail = {};
      // validate status outlet or account client
      if (dataOutlet.status === "active") {
        // get data voucher number with parameters qr
        let res_voucher_number = await axios.get(
          `${process.env.REACT_APP_BASE_URL_API}/v2/project/voucher/searchVoucherNumber/${qrResult}`,
          { headers: HEADER },
        );
        // check voucher number exists
        if (res_voucher_number?.data?.data[0]) {
          detail = res_voucher_number.data.data[0];
          // check voucher expired
          let now = moment().utc();
          let date_end = moment.utc(detail.voucher_number_end);
          // validate voucher expired
          if (date_end.isSameOrAfter(now)) {
            // get data redeemer by voucher_number_id

            let res_redeemer = await axios.get(
              `${process.env.REACT_APP_BASE_URL_API}/v2/collection/redeemer/data`,
              {
                params: {
                  voucher_assignment_id: detail.voucher_assignment_id ?? "",
                  voucher_number_id: detail.voucher_number_id ?? "",
                },
                headers: HEADER,
              },
            );
            // Check The Voucher Have Redeemer
            if (_.isArray(res_redeemer.data.data)) {
              res_redeemer = res_redeemer.data.data;
              // Check Status Voucher
              if (detail.voucher_number_status !== "redeemed") {
                let confirmVoucher = false;
                for (let index = 0; index < res_redeemer.length; index++) {
                  // Check Validation Redeemer
                  if (
                    _.isEmpty(res_redeemer[index].open_status_date) &&
                    !_.isEmpty(res_redeemer[index].activated_status_date) &&
                    _.isEmpty(res_redeemer[index].redeemed_status_date)
                  ) {
                    confirmVoucher = true;
                    detail = Object.assign(detail, res_redeemer[index]);
                    break;
                  }
                }
                if (confirmVoucher) {
                  // channel voucher must be the same as channel outlet
                  if (
                    detail.channel_id === dataOutlet.channel_id ||
                    detail.status === "demo"
                  ) {
                    // Get detail project
                    let project = await getDataAxios(
                      `${process.env.REACT_APP_BASE_URL_API}/project/${detail.project_id}`,
                    );
                    project = project.data.data;

                    if (!detail.sku_name) {
                      // get data sku by sku_id
                      let res_sku = await axios.get(
                        `${process.env.REACT_APP_BASE_URL_API}/sku/${detail.sku_id}`,
                        { headers: HEADER },
                      );
                      res_sku = res_sku.data.data;
                      if (res_sku) {
                        detail = Object.assign(detail, res_sku);
                      }
                    }
                    if (!detail.brand_name) {
                      // get data brand by brand_id
                      let res_brand = await axios.get(
                        `${process.env.REACT_APP_BASE_URL_API}/brand/${detail.brand_id}`,
                        { headers: HEADER },
                      );
                      res_brand = res_brand.data.data;
                      if (res_brand) {
                        detail = Object.assign(detail, res_brand);
                      }
                    }

                    // get data channel to get ewallet status   information
                    if (project.status === "active") {
                      let channel = await getDataAxios(
                        `${process.env.REACT_APP_BASE_URL_API}/channel/${dataOutlet.channel_id}`,
                      );
                      channel = channel.data.data;
                      // asign ewallet status from channel
                      detail = {
                        ...detail,
                        ...project,
                        ewallet_status: channel.ewallet_status,
                      };

                      // get data client by client id
                      let res_client = await axios.get(
                        `${process.env.REACT_APP_BASE_URL_API}/client/${detail.client_id}`,
                        { headers: HEADER },
                      );
                      res_client = res_client.data.data;
                      if (res_client) {
                        detail = Object.assign(detail, res_client);
                      }
                      let isAllowToRedeem = false;
                      // check when voucher expire periode but customer can still redeemed voucher after 5 days when activated voucher
                      if (detail.status_voucher === "inactive") {
                        const start = moment(detail.activated_status_date);
                        const end = moment(
                          moment(detail.activated_status_date).add(5, "days"),
                        );
                        isAllowToRedeem = moment().isBetween(start, end);
                      } else if (detail.voucher_number_status === "activated") {
                        isAllowToRedeem = true;
                      }
                      if (isAllowToRedeem) {
                        // Get Setting Custom
                        let settingsOveride = await axios.get(
                          `${process.env.REACT_APP_BASE_URL_API}/outlet/clientAssignment`,
                          {
                            params: {
                              channel_id: dataOutlet.channel_id,
                              outlet_kartini_id: dataOutlet.outlet_kartini_id,
                              project_id: detail.project_id,
                            },
                            headers: HEADER,
                          },
                        );
                        navigate("/confirm-voucher", {
                          state: {
                            detailVoucher: detail,
                            settingsOveride: settingsOveride?.data?.data[0]
                              ?.setting
                              ? JSON.parse(
                                  settingsOveride?.data?.data[0]?.setting,
                                )
                              : {},
                          },
                        });
                      } else {
                        if (detail.status_voucher === "inactive") {
                          setSheetDetail({
                            title: "Voucher Inactive",
                            detail:
                              "This voucher is currently inactive and cannot be redeemed. If you believe this is a mistake, contact our support team.",
                            open: true,
                          });
                        } else {
                          setSheetDetail({
                            title: "Voucher Cannot Be Redeemed",
                            detail:
                              "This voucher cannot be redeemed at this time. If you believe this is a mistake, contact our support team.",
                            open: true,
                          });
                        }
                      }
                    } else {
                      setSheetDetail({
                        title: "Project Inactive",
                        detail:
                          "This project is currently inactive and cannot be accessed. If you believe this is a mistake, contact our support team.",
                        open: true,
                      });
                    }
                  } else {
                    setSheetDetail({
                      title: "Voucher Not Match the Store",
                      detail:
                        "Sorry, the voucher you entered does not match the store. Please double-check the voucher code and try again. If you're unsure, please ensure you're redeeming the voucher at the correct store. If you continue to experience issues, reach out to our support team.",
                      open: true,
                    });
                  }
                } else {
                  setSheetDetail({
                    title: "Voucher Rejected",
                    detail:
                      "We're sorry, but the voucher you entered has been rejected. Please ensure the voucher code is correct and try again. If you're still encountering issues, please contact our support team.",
                    open: true,
                  });
                }
              } else {
                setSheetDetail({
                  title: "Voucher Already Utilized",
                  detail: (
                    <>
                      <div>
                        Redeemed on{" "}
                        <strong>
                          {moment(res_redeemer[0].redeemed_status_date).format(
                            "DD-MM-YYYY HH:mm",
                          )}
                        </strong>{" "}
                        at{" "}
                        <strong>{res_redeemer[0].outlet_kartini_name}</strong>.
                        Please double-check the voucher code and try again with
                        a valid one. If you need further assistance, feel free
                        to reach out to our support team.
                      </div>
                    </>
                  ),
                  open: true,
                });
              }
            } else {
              setSheetDetail({
                title: "Transaction Not Found",
                detail:
                  "We couldn't find the transaction you're looking for. Please double-check the details and try again. If you believe this is an error, feel free to reach out to our support team.",
                open: true,
              });
            }
          } else {
            setSheetDetail({
              title: "Voucher Expired",
              detail:
                "Sorry, the voucher you entered has expired and can no longer be redeemed. Please check the expiration date of the voucher and try again with a valid one. If you have any questions or need further assistance, don't hesitate to contact our support team.",
              open: true,
            });
          }
        } else {
          setSheetDetail({
            title: "Voucher Not Found",
            detail:
              "Oops! We couldn't find the voucher you entered. Please double-check the voucher code and try again. If you continue to experience issues, please reach out to our support team.",
            open: true,
          });
        }
      } else {
        setSheetDetail({
          title: "Feature Access Denied",
          detail:
            "Sorry, you can't use this feature at the moment. If you believe this is an error or need assistance, please contact our support team.",
          open: true,
        });
      }
    } catch (error) {
      console.error(error);
    }
    setShowModalLoading(false);
  }

  return (
    <>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <div className="mb-5 space-y-5">
        {/* <div className="flex space-x-2">
               <button
                  className={`btn ${
                     typeScan === "qr"
                        ? "bg-[#4CA6F8] text-white"
                        : "border-slate-200 hover:border-slate-300 text-slate-600"
                  }`}
                  // className="btn bg-[#4CA6F8] text-white disabled:bg-[#CCCCCC] disabled:text-[#7D7C7C] disabled:cursor-not-allowed"
                  onClick={(e) => setTypeScan("qr")}
                  // disabled={isDisabled}
               >
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     strokeWidth={1.5}
                     stroke="currentColor"
                     className="w-5 h-5 mr-2"
                  >
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"
                     />
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"
                     />
                  </svg>
                  Scan QR Code
               </button>
               <button
                  className={`btn ${
                     typeScan === "barcode"
                        ? "bg-[#4CA6F8] text-white"
                        : "border-slate-200 hover:border-slate-300 text-slate-600"
                  }`}
                  onClick={(e) => setTypeScan("barcode")}
                  // disabled={isDisabled}
               >
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     strokeWidth={1.5}
                     stroke="currentColor"
                     className="w-5 h-5 mr-2"
                  >
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                     />
                  </svg>
                  Scan Barcode
               </button>
            </div> */}
        <div>
          {/* Fragment */}
          {/* <QRScanner setQrResult={setQrResult} /> */}
          <div className="flex h-64 items-center justify-center rounded-md bg-gray-400 px-5">
            <V2MigrationBanner text="Silahkan melakukan redemption di " />
          </div>
          {/* {typeScan === "qr" ? (
                  <QRScanner setQrResult={setQrResult} />
               ) : (
                  <BarcodeScanner setQrResult={setQrResult} />
               )} */}
        </div>
        <input
          id="qr-code"
          placeholder="Unique Voucher Code"
          value={qrResult}
          onChange={(e) => setQrResult(e.target.value)}
          disabled
          className="form-input text-md h-12 w-full"
          type="text"
        />
        <ButtonRequire
          title="CONFIRM UNIQUE VOUCHER CODE"
          functionOnClick={getDetailVoucher}
          isDisabled={_.isEmpty(qrResult)}
        />
      </div>
      <ErrorSheet sheetDetail={sheetDetail} setSheetDetail={setSheetDetail} />
    </>
  );
}
